import { GUIDES, type MarketingLocale } from './guides';

export type MarketingPage = 'home' | 'product' | 'demo' | 'examples' | 'service' | 'extension' | 'insights' | 'article';
export type MarketingRoute = { page: MarketingPage; locale: MarketingLocale; path: string; slug?: string };
export const MARKETING_LOCALES: MarketingLocale[] = ['en', 'zh-Hans', 'zh-Hant'];

export function marketingPath(page: MarketingPage, locale: MarketingLocale, slug?: string): string {
  const suffix = locale === 'en' ? '' : `/${locale.toLowerCase()}`;
  if (page === 'home') return locale === 'en' ? '/' : '/zh/';
  if (page === 'extension') return locale === 'en' ? '/extension/' : '/zh/extension/';
  if (page === 'insights' || page === 'article') return `/insights${suffix}/${slug ? `${slug}/` : ''}`;
  if (page === 'demo') return `/buyer-radar${suffix}/demo/`;
  return `/buyer-radar${suffix}/${page === 'product' ? '' : `${page === 'service' ? 'pilot' : 'examples'}/`}`;
}

export const MARKETING_ROUTES: MarketingRoute[] = [
  ...(['home', 'extension'] as const).flatMap(page => (['en', 'zh-Hans'] as const).map(locale => ({ page, locale, path: marketingPath(page, locale) }))),
  ...(['product', 'demo', 'examples', 'service', 'insights'] as const).flatMap(page => MARKETING_LOCALES.map(locale => ({ page, locale, path: marketingPath(page, locale) }))),
  ...GUIDES.flatMap(guide => MARKETING_LOCALES.map(locale => ({ page: 'article' as const, locale, slug: guide.slug, path: marketingPath('article', locale, guide.slug) }))),
];

export function matchMarketingRoute(pathname: string): MarketingRoute | null {
  const normalized = pathname === '/' ? '/' : `${pathname.replace(/\/$/, '')}/`;
  return MARKETING_ROUTES.find(route => route.path === normalized) ?? null;
}

export function routeAlternates(route: MarketingRoute): MarketingRoute[] {
  return MARKETING_ROUTES.filter(item => item.page === route.page && item.slug === route.slug);
}
